
import { observable, action, runInAction, toJS } from 'mobx';
import defaultData, { costData, depositData } from "./data";
import moment from 'moment';
import { message } from 'antd';
import { calculation } from "@/method"
import _ from "lodash";

const listName = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

const defaultNotes = {
    cashFlow: "",
    accountsReceivable: "",
    inventory: "",
    profit: "",
    business: "",
    cost: "",
    name: "",
    date: moment().format('YYYY-MM-DD')
};

class store {
    @observable date = moment().subtract(1, 'month').format('YYYY');
    @observable data = [...defaultData];
    @observable loading = false;
    @observable saving = false;
    @observable notes = { ...defaultNotes };
    @observable cost = _.cloneDeep(costData);
    @observable deposit = _.cloneDeep(depositData);

    @action
    getData = async (date) => {
        runInAction(() => {
            this.loading = true;
            this.data = [];
        });
        try {

            const year = moment(date).format('YYYY');
            const url = `/monthlyAnalysis?year=${year}`;
            let json = await fetch(url, { credentials: 'include' });
            let res = await json.json();
            let _deposit = (res.data.deposit || []).reduce((a, b) => {
                a[b.month] = b; return a
            }, {});
            let deposit = _.cloneDeep(depositData);
            if (res.data.deposit && res.data.deposit.length) deposit = ['Adjusted', 'Debit', 'Credit', 'Current'].map((name, j) => {
                return {
                    name: depositData[j].name,
                    ...listName.reduce((a, b, i) => {
                        a[b] = (_deposit[i + 1] || {})[name] || 0;
                        return a
                    }, {})
                }
            });
            console.log(deposit);
            const data = compute(res.data);
            const cost = computeCost(res.data);


            runInAction(() => {
                this.loading = false;
                this.deposit = deposit;
                this.data = data && data.length > 0 ? data : [...defaultData];
                this.notes = { ...defaultNotes, ...res.data.notes };
                this.cost = cost && cost.length > 0 ? cost : _.cloneDeep(costData);
            });

        } catch (error) {
            console.error(error);
            message.error('数据处理失败！');
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    @action
    onSave = async () => {
        let date = this.date;
        let data = toJS(this.data).map(x => {
            return Object.keys(x).reduce((a, b) => {
                if (!b.includes('minus')) a[b] = x[b];
                return a
            }, { year: date })
        });
        let cost = toJS(this.cost).map(x => ({ ...x, year: date }));
        let notes = { ...toJS(this.notes), year: date };

        if (!notes.name) return message.error('请输入填写人姓名');
        runInAction(() => { this.saving = true });
        try {
            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            dataFrom.append('cost', JSON.stringify(cost));
            dataFrom.append('notes', JSON.stringify(notes));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            let json = await fetch('/addMonthlyAnalysis', headres);
            let res = await json.json();

            if (res.status == 1) {
                message.success('保存成功！');
                if (!data[0].id || !notes.id) {
                    this.getData(this.date);
                }
            } else {
                message.error(res.msg);
            }
            runInAction(() => { this.saving = false });
        } catch (error) {
            message.error('保存失败！');
            console.error(error);
            runInAction(() => { this.saving = false });
        }
    }
}

const Month = new store();

export default Month;

function compute({
    data = [], cash = [], income = [],
    room = [], fb = [], gop = [], account = [], inventories = [],
    food = [], gops = [], incomeLast = [], gopsLast = []
}) {
    if (!data.length) data = defaultData;

    cash = cash.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    income = income.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    income[0] = _.get(incomeLast, `0`) || { actual: 0 };
    account = account.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    inventories = inventories.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    food = food.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    gops = gops.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    gops[0] = _.get(gopsLast, `0`) || { actual: 0 };
    room = room.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});

    fb = fb.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    gop = gop.reduce((a, b) => {
        a[b.month] = b; return a
    }, {});
    ['Adjusted', 'Debit', 'Credit', 'Current'].forEach((name, i) => {
        data[i] = listName.reduce((a, b, i) => {
            a[b] = _.get(cash, `${i + 1}.${name}`) || 0;
            return a
        }, { ...data[i] });
    });

    data[4] = listName.reduce((a, b, i) => {
        const index = i + 1;
        a[b] = (30 / (_.get(income, `${index}.actual`) / (((_.get(account, `${index}.Adjusted`) || 0) / 2) + (_.get(account, `${index}.Current`) / 2))) || 0).toFixed(0);
        return a
    }, { ...data[4] });

    data[5] = listName.reduce((a, b, i) => {
        const index = i + 1;
        a[b] = (30 / (_.get(food, `${index}.actual`) / (((_.get(inventories, `${index}.Adjusted`) || 0) / 2) + (_.get(inventories, `${index}.Current`) / 2))) || 0).toFixed(0);
        return a
    }, { ...data[5] });

    data[6] = listName.reduce((a, b, i) => {
        a[b] = _.get(room, `${i + 1}.actual`) || 0;
        return a
    }, { ...data[6] });
    data[7] = listName.reduce((a, b, i) => {
        a[b] = _.get(fb, `${i + 1}.actual`) || 0;
        return a
    }, { ...data[7] });
    data[8] = listName.reduce((a, b, i) => {
        a[b] = _.get(gop, `${i + 1}.actual`) || 0;
        return a
    }, { ...data[8] });

    data[9] = listName.reduce((a, b, i) => {
        const index = i + 1;
        a[b] = calculation(
            _.get(income, `${index}.actual`, 0) - _.get(income, `${index - 1}.actual`, 0),
            _.get(income, `${index - 1}.actual`, 0), 4
        );
        return a
    }, { ...data[9] });
    data[10] = listName.reduce((a, b, i) => {
        const index = i + 1;
        a[b] = calculation(
            _.get(gops, `${index}.actual`, 0) - _.get(gops, `${index - 1}.actual`, 0),
            _.get(gops, `${index - 1}.actual`, 0), 4
        );
        if (index > 0 && _.get(gops, `${index}.actual`, 0) > _.get(gops, `${index - 1}.actual`, 0) && _.get(gops, `${index - 1}.actual`, 0) < 0) {
            a[b + 'minus'] = true;
        }

        return a
    }, { ...data[10] });
    return data
}

function computeCost({
    cost, costRate
}) {
    if (!cost.length) cost = _.cloneDeep(costData);
    const costName = ['food', 'human', 'energy', 'other'];
    cost = costName.map((name, i) => {
        return {
            ...cost[i], ...listName.reduce((a, b, j) => {
                a[b] = (costRate[name].find(x => x.month == (j + 1)) || {}).actual || 0;
                return a
            }, {})
        }
    });
    return cost
}


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/store.js